<button (click)="logout()" mat-raised-button color="primary" style="margin-left: 85%; margin-top: 10px">
  {{'admin-manager.logout'|translate}}</button><br><br>
<mat-progress-bar *ngIf="changes" mode="indeterminate"></mat-progress-bar><br>
<div>
  <mat-card style="min-width: 500px">
    <h2 mat-line>{{'admin-manager.card-1-title'|translate}}</h2>
    <mat-list role="list">
      <ng-container *ngFor="let req of requests.requests; let i = index">
        <mat-list-item role="listitem">
          <div style="width: 80%; overflow-wrap: break-word;">
            {{req.name}}&emsp;-&emsp;{{basetos(req.email)}}
          </div>
          <button (click)="acceptRequest(req)"
                  style="margin-left: 50px" mat-icon-button aria-label="Example icon-button with a heart icon">
            <mat-icon>done</mat-icon>
          </button>
          <!-- TODO delete user
          <button (click)="deleteRequest(req)"
                  style="margin-left: 50px" mat-icon-button aria-label="Example icon-button with a heart icon">
            <mat-icon>delete_forever</mat-icon>
          </button>
          -->
        </mat-list-item>
        <mat-divider *ngIf="i < requests.requests.length-1"></mat-divider>
      </ng-container>
    </mat-list>
  </mat-card>
</div>

<div large="true">
  <mat-card style="min-width: 500px">
    <h2 mat-line>{{'admin-manager.card-2-title'|translate}}</h2>
    <mat-list role="list">
      <ng-container *ngFor="let soft of softwares.softwares; let i = index">
        <mat-list-item role="listitem" *ngIf="soft.email != '' && !soft.approved">
          <div style="width: 80%; overflow-wrap: break-word;">
            {{soft.software_name}}&emsp;-&emsp;{{basetos(soft.email)}}
          </div>
          <button (click)="acceptAdminSoftwareRequest(soft)"
                  style="margin-left: 50px" mat-icon-button aria-label="Example icon-button with a heart icon">
            <mat-icon>done</mat-icon>
          </button>
        </mat-list-item>
        <mat-divider *ngIf="i < requests.requests.length-1"></mat-divider>
      </ng-container>
    </mat-list>
  </mat-card>
</div>

<div large="true">
  <mat-card style="min-width: 500px">
    <h2 mat-line>{{'admin-manager.card-3-title'|translate}}</h2>
    <mat-list role="list">
      <h4 mat-line>Da attivare</h4>
      <ng-container *ngFor="let vps of vpsList; let i = index">
        <mat-list-item role="listitem" *ngIf="!vps.running && vps.active">
          <div style="width: 80%; overflow-wrap: break-word;">
            {{basetos(vps.email)}}&emsp;-&emsp;{{vps.softwares}}&emsp;-&emsp;free: {{vps.free_plan}}&emsp;-&emsp;{{
            vps.id_conto
            }}&emsp;-&emsp;{{vps.broker_server}}&emsp;-&emsp;{{vps.password_conto}}&emsp;-&emsp;
            <span matTooltip="Informazioni VPS" class="label label-inverse label-rounded" (click)="changeVpsActivationState(vps.email,'activating')">In attivazione</span>
            <span matTooltip="Informazioni VPS" class="label label-success label-rounded" (click)="changeVpsActivationState(vps.email,'data_ok')">Attivo</span>
            <span matTooltip="Informazioni VPS" class="label label-danger label-rounded" (click)="changeVpsActivationState(vps.email,'cred_wrong')">Credenziali errate</span>
            <span matTooltip="Informazioni VPS" class="label label-info label-rounded" (click)="changeVpsActivationState(vps.email,'maintaining')">Manutenzione</span>
          </div>
        </mat-list-item>
        <mat-divider *ngIf="i < requests.requests.length-1"></mat-divider>
      </ng-container>
    </mat-list>
    <mat-list role="list">
      <h4 mat-line>Attivi</h4>
      <ng-container *ngFor="let vps of vpsList; let i = index">
        <mat-list-item role="listitem" *ngIf="vps.running && vps.active">
          <div style="width: 80%; overflow-wrap: break-word;">
            {{basetos(vps.email)}}&emsp;-&emsp;{{vps.softwares}}&emsp;-&emsp;free: {{vps.free_plan}}&emsp;-&emsp;{{
            vps.id_conto
            }}&emsp;-&emsp;{{vps.broker_server}}&emsp;-&emsp;{{vps.password_conto}}&emsp;-&emsp;
            <span matTooltip="Informazioni VPS" class="label label-inverse label-rounded" (click)="changeVpsActivationState(vps.email,'activating')">In attivazione</span>
            <span matTooltip="Informazioni VPS" class="label label-success label-rounded" (click)="changeVpsActivationState(vps.email,'data_ok')">Attivo</span>
            <span matTooltip="Informazioni VPS" class="label label-danger label-rounded" (click)="changeVpsActivationState(vps.email,'cred_wrong')">Credenziali errate</span>
            <span matTooltip="Informazioni VPS" class="label label-info label-rounded" (click)="changeVpsActivationState(vps.email,'maintaining')">Manutenzione</span>
          </div>
        </mat-list-item>
        <mat-divider *ngIf="i < requests.requests.length-1"></mat-divider>
      </ng-container>
    </mat-list>
  </mat-card>
</div>
